module.exports = __webpack_public_path__ + "website/img/Yoyo_C_03.ac16eb97.jpeg";